import PropTypes from "prop-types";
import { useWatch } from "react-hook-form";

import {
  FormMultiSelect,
  FormSelect,
  FormToggle,
  SectionCard,
} from "components/BaseForm";

const EmailSection = ({
  emailServiceOptions,
  emailTypeOptions,
  templateOptions,
}) => {
  const isLimitingTemplates = useWatch({ name: "limit_email_templates" });

  return (
    <SectionCard title="Email">
      <div className="tw:grid tw:grid-cols-1 tw:gap-5 tw:sm:grid-cols-2">
        <FormSelect
          name="email_service"
          label="Email Service"
          required
          options={emailServiceOptions}
        />
        <FormSelect
          name="email_type"
          label="Email Type"
          required
          options={emailTypeOptions}
        />
        <FormToggle
          name="limit_email_templates"
          label="Limit Email Templates"
          className="tw:sm:col-span-2"
        />
        {isLimitingTemplates && (
          <FormMultiSelect
            name="email_templates"
            label="Templates"
            options={templateOptions}
            className="tw:sm:col-span-2"
          />
        )}
      </div>
    </SectionCard>
  );
};

EmailSection.propTypes = {
  emailServiceOptions: PropTypes.array.isRequired,
  emailTypeOptions: PropTypes.array.isRequired,
  templateOptions: PropTypes.array.isRequired,
};

export default EmailSection;
